module.exports = __webpack_public_path__ + "static/media/gps-on-vermont-medical-centre-news.8b639802.jpg";